import React, { useEffect, useState } from 'react';
import fallbackLogo from '../../../assets/images/Voxtur-verify.png';

const isUsableSrc = (src) =>
  typeof src === 'string' && src.trim() !== '' && src.trim().toLowerCase() !== 'null';

const Logo = React.memo(
  ({ src, width = 170, height = 55 }) => {
    const resolved = isUsableSrc(src) ? src.trim() : fallbackLogo;
    const [imgSrc, setImgSrc] = useState(resolved);

    useEffect(() => {
      setImgSrc(isUsableSrc(src) ? src.trim() : fallbackLogo);
    }, [src]);

    return (
      <img
        src={imgSrc}
        alt='ClientVerify'
        onError={() => {
          if (imgSrc !== fallbackLogo) {
            setImgSrc(fallbackLogo);
          }
        }}
        style={{
          width: `${width}px`,
          height: `${height}px`,
          objectFit: 'contain',
          objectPosition: 'left center',
          display: 'block',
          flexShrink: 0,
        }}
      />
    );
  },
  (prevProps, nextProps) => prevProps?.src === nextProps?.src
);

export default Logo;
